// libs
import { styled } from '@nykaa/ui-components';
import { FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const LoginNudgeContainer = styled.div`
  position: relative;
`;

export const LoaderContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing10};
  pointer-events: none;
`;

export const WishlistButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;

  ${FOCUS_VISIBILITY_CSS}
`;
